import React from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";
import { Container } from "reactstrap";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "routes.js";
import { getLoginType } from "../services/httpServices";
import { routePermissions } from "services/util";

const DisbursementManager = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      let layout = null;
      let route = routePermissions.find((i) => i.name === getLoginType());
      if (prop.common === true) {
        layout = (
          <Route path={prop.path} component={prop.component} key={key} />
        );
      } else if (route?.name) {
        if (
          prop.layout === route.layout ||
          (prop.allow &&
            prop.allow.length &&
            prop.allow.indexOf(route.name) > -1)
        ) {
          layout = (
            <Route path={prop.path} component={prop.component} key={key} />
          );
        } else {
          layout = null;
        }
      }
      return layout;
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (props.location.pathname === routes[i].path) {
        return routes[i].name;
      }
    }
    return "Disbursement Manager";
  };

  return (
    <>
      <Sidebar
        {...props}
        routes={routes}
        logo={{
          innerLink: "/disbursement-manager/index",
          imgSrc: require("../assets/img/brand/lapologo.PNG").default,
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(props.location.pathname)}
        />
        <Switch>
          {getRoutes(routes)}
          <Redirect from="*" to="/index" />
        </Switch>
        <Container fluid>{/* <AdminFooter /> */}</Container>
      </div>
    </>
  );
};

export default DisbursementManager;
